import { Box, Typography } from "@mui/material";
import { whiteColor } from "configs/styles/muiThemes";
import React from "react";
import { useNavigate } from "react-router-dom";

const FreeShippmentBanner = ({ commercialDetails }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        position: "relative",
        p: "0 16px",
        my: "14px",
      }}
      onClick={() =>
        navigate(`/${sessionStorage.getItem("businessName")}/dealsCoupons`)
      }
    >
      <Box
        component="img"
        src="/assets/images/new/discount-card.svg"
        sx={{ width: "100%", height: "72px" }}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          position: "absolute",
          left: "25px",
          mt: 0.5,
        }}
      >
        <Box position="relative">
          <Box
            component="img"
            src="/assets/images/new/offer-card.svg"
            sx={{ width: "45px", height: "45px" }}
          />
          <Box
            component="img"
            src="/assets/images/new/free-delivery-truck.svg"
            sx={{
              width: "30px",
              position: "absolute",
              top: "9px",
              left: "9px",
            }}
          />
        </Box>

        <Box mt={-1}>
          <Typography
            fontSize={13}
            fontWeight={600}
            color={whiteColor}
            lineHeight="16px"
          >
            Get free delivery
          </Typography>
          <Typography
            fontSize={11}
            fontWeight={500}
            color={whiteColor}
            lineHeight="18px"
          >
            Free Shipping above ₹{commercialDetails?.info?.immediateDiscount}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FreeShippmentBanner;
